import logoInverted from 'assets/logos/logoInverted.svg';
import logoSmall from 'assets/logos/logoSmall.svg';
import downOutlined from 'assets/svgs/downOutlined.svg';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const Root = styled.header`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 16px;
  gap: 8px;
  border-bottom: 1px solid #d9d9d9;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding: 8px 24px;
    gap: 16px;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    height: 56px;
    padding: 8px 32px;
  }
`;

export const Icon = styled.a`
  display: block;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
  color: transparent;
  text-decoration: none;
`;

export const Logo = styled(Icon)`
  width: 32px;
  height: 26px;
  background-image: url(${logoSmall});
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    width: 80px;
    height: 40px;
    background-image: url(${logoInverted});
  }
`;

export const DownOutlined = styled(Icon)`
  width: 16px;
  height: 16px;
  background-image: url(${downOutlined});
`;

export const HeaderItem = styled.div`
  display: none;
  flex-direction: column;
  gap: 2px;
`;

export const UserMenu = styled(HeaderItem)`
  width: 160px;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    display: flex;
  }
`;

export const ClientMenu = styled(HeaderItem)`
  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: flex;
  }

  .antd-dropdown-trigger {
    cursor: pointer;
  }
`;

export const UserAmount = styled(HeaderItem)`
  width: 156px;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: flex;
  }
`;

export const UserMenuButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  gap: 4px;
  border: 0;
  background: transparent;
`;

export const ClientMenuButton = styled(UserMenuButton)``;

export const Text = styled.span<{ $small?: boolean }>`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: ${({ small }) => (small ? '0.625rem' : '0.875rem')};
  color: ${({ small }) => (small ? '#8c8c8c' : '#000')};
  text-align: start;
  white-space: break-spaces;
`;

export const UserName = styled(Text)`
  width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SearchBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;

  button {
    margin-left: -2px;
    min-width: 32px;
  }
`;

export const AmountDisplay = styled.div`
  display: flex;
  gap: 4px;
`;

export const SignIn = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  width: 78px;
  height: 32px;
  border: 0;
  border-radius: 2px;
  padding: 8px;
  gap: 4px;
  background-color: #f78e1e;
  cursor: pointer;

  span {
    color: #fff;
  }

  svg {
    width: 20px;
    height: 20px;
    color: #fff;
  }
`;

export const MobileMenuButton = styled.button.attrs({ type: 'button' })`
  width: 32px;
  height: 32px;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  background-color: #fff;
  cursor: pointer;

  svg {
    color: #000;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    display: none;
  }
`;

export const HideOnMobile = styled.div`
  display: none;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: block;
  }
`;

export const RightAlignedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-wrap: wrap;
`;

export const SearchInputWrapper = styled.div`
  padding: 8px;

  .ant-input-affix-wrapper {
    &:hover,
    &:focus,
    &:focus-within {
      border-color: #f78e1e !important;
      box-shadow: 0 0 0 2px rgba(247, 142, 30, 0.1) !important;
    }
  }
`;
